import * as React from "react"

function PrintSvgComponent (props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20.451}
            height={20.451}
            viewBox="0 0 50.451 50.451"
            {...props}
        >
            <path
                data-name="Path 25509"
                d="M10.346 20.692H4.434a1.477 1.477 0 01-1.478-1.478v-5.912A4.439 4.439 0 017.39 8.868h2.956a1.477 1.477 0 011.478 1.478v8.868a1.477 1.477 0 01-1.478 1.478z"
                fill="#57555c"
            />
            <path
                data-name="Path 25510"
                d="M47.494 19.214a1.477 1.477 0 01-1.478 1.478h-5.912a1.477 1.477 0 01-1.478-1.478l-2.956-8.868a1.477 1.477 0 011.478-1.478h5.912a4.439 4.439 0 014.434 4.434z"
                fill="#3c3a41"
            />
            <path
                data-name="Path 25511"
                d="M41.582 11.824v7.39a1.464 1.464 0 01-1.478 1.478H10.346a1.464 1.464 0 01-1.478-1.477V1.478A1.464 1.464 0 0110.346 0h19.412l2.956 8.868z"
                fill="#e5e5e5"
            />
            <path
                data-name="Path 25512"
                d="M40.104 20.693H25.225V0h4.533l2.956 8.868 8.868 2.956v7.39a1.464 1.464 0 01-1.478 1.479z"
                fill="#d9d9d9"
            />
            <path
                data-name="Path 25513"
                d="M46.017 17.737H4.434A4.428 4.428 0 000 22.171v17.934a4.428 4.428 0 004.434 4.432h41.583a4.428 4.428 0 004.434-4.434V22.171a4.428 4.428 0 00-4.434-4.434z"
                fill="#1ba9ef"
            />
            <path
                data-name="Path 25514"
                d="M29.758 10.346a1.464 1.464 0 001.478 1.478h10.346L29.758 0z"
                fill="#fe9923"
            />
            <path
                data-name="Path 25515"
                d="M50.45 22.171v17.934a4.428 4.428 0 01-4.434 4.434H25.225V17.737h20.791a4.428 4.428 0 014.434 4.434z"
                fill="#1689fc"
            />
            <path
                data-name="Path 25516"
                d="M10.346 26.605H7.39a1.478 1.478 0 010-2.956h2.956a1.478 1.478 0 010 2.956z"
                fill="#e1e4fb"
            />
            <path
                data-name="Path 25517"
                d="M41.582 31.533v17.44a1.464 1.464 0 01-1.478 1.478H10.346a1.464 1.464 0 01-1.478-1.478v-17.44z"
                fill="#e5e5e5"
            />
            <path
                data-name="Path 25518"
                d="M41.582 31.533v17.44a1.464 1.464 0 01-1.478 1.478H25.225V31.533z"
                fill="#d9d9d9"
            />
            <g data-name="Group 770" fill="#aeadb3">
                <path
                    data-name="Path 25519"
                    d="M35.67 37.148a1.464 1.464 0 01-1.478 1.478H16.258a1.478 1.478 0 010-2.956h17.934a1.464 1.464 0 011.478 1.478z"
                />
                <path
                    data-name="Path 25520"
                    d="M35.67 43.06a1.464 1.464 0 01-1.478 1.478H16.258a1.478 1.478 0 010-2.956h17.934a1.463 1.463 0 011.478 1.478z"
                />
            </g>
            <g data-name="Group 771" fill="#8b8892">
                <path
                    data-name="Path 25521"
                    d="M35.67 43.06a1.464 1.464 0 01-1.478 1.478h-8.967v-2.956h8.967a1.463 1.463 0 011.478 1.478z"
                />
                <path
                    data-name="Path 25522"
                    d="M35.67 37.148a1.464 1.464 0 01-1.478 1.478h-8.967V35.67h8.967a1.464 1.464 0 011.478 1.478z"
                />
            </g>
            <path
                data-name="Path 25523"
                d="M44.538 31.236a1.464 1.464 0 01-1.478 1.478H7.39a1.478 1.478 0 110-2.956h35.67a1.463 1.463 0 011.478 1.478z"
                fill="#57555c"
            />
            <path
                data-name="Path 25524"
                d="M44.538 31.236a1.464 1.464 0 01-1.478 1.478H25.225v-2.956H43.06a1.463 1.463 0 011.478 1.478z"
                fill="#3c3a41"
            />
        </svg>
    )
}

export default PrintSvgComponent
